<template>
  <div class="pt-5 mr-3 dateSelect">
    <v-select
      :items="dateTypes"
      v-model="selectedDateTypes"
      item-text="title"
      required
      dense
      solo
      return-object
      @change="changeDataType"
    ></v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DataPicker",

  data: () => ({
      dateTypes: [
          {
            id: '%m',
            title: 'month',
            bigquery_name: 'month'
          },
          {
            id: 'w%U',
            title: 'week',
            bigquery_name: 'isoweek'
          },
          {
            id: '%m, %d',
            title: 'day',
            bigquery_name: 'day'
          }
        ],
      selectedDateTypes: null,
    }),

  computed: {
    ...mapGetters({
      datesrangetype: "datesrangetype",
    }),
  },

  methods: {
    changeDataType(){
      // console.log(value.id)
      this.$store.dispatch("setDatesRangeType", this.selectedDateTypes);
    },
  },

  mounted(){
    this.selectedDateTypes = this.datesrangetype
  },

}
</script>

<style scoped>
.dateSelect  {
  max-width: 120px;
}
</style>